import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAdmin } from '@/context/AdminContext'
import Loading from '@/components/UI/Loading'

const ProtectedRoute = ({ children }) => {
  const { isAdmin } = useAdmin()
  const location = useLocation()

  // Show loading while checking authentication
  if (isAdmin === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading />
      </div>
    )
  }

  // If not authenticated, redirect to admin login
  if (!isAdmin) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />
  }

  // If authenticated, render the protected component
  return children
}

export default ProtectedRoute
